/**
 * @file Account related queries.
 */
import gql from 'graphql-tag';

import { TransactionItemDetails } from '../../../../graphql/fragments/transaction';
import { UserDetails } from '../fragments/account';

export const MeQuery = gql`
  query meQuery {
    me {
      contact_phone
      roles
      email_verified
      active
      organization_name
      roles
      ...UserDetails
    }
  }
  ${UserDetails}
`;

export const MeWithRoles = gql`
  query meWithRoles {
    me {
      id
      roles
      ...UserDetails
    }
  }
  ${UserDetails}
`;

export const AccountTransaction = gql`
  query accountTransaction($transaction_id: RecordID!) {
    accountTransaction(transaction_id: $transaction_id) {
      id
      uuid
      order_number
      total_price {
        value
        currency
      }
      transaction_items(slice: { limit: 999 }) {
        records {
          ...TransactionItemDetails
        }
      }
    }
  }
  ${TransactionItemDetails}
`;
